type Kind = 'info' | 'success' | 'error';
const COLORS: Record<Kind, string> = {
  info: '#2563eb',
  success: '#16a34a',
  error: '#ef4444'
};

/**
 * showToast(message, kind?, ttl?)
 * - simple, sin dependencias.
 * - crea un nodo DOM, lo muestra y lo elimina al ttl (ms).
 */
export function showToast(message: string, kind: Kind = 'info', ttl = 3000) {
  try {
    const rootId = 'simple-toast-root';
    let root = document.getElementById(rootId);
    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      root.style.position = 'fixed';
      root.style.top = '12px';
      root.style.right = '12px';
      root.style.zIndex = '100000';
      root.style.display = 'flex';
      root.style.flexDirection = 'column';
      root.style.gap = '8px';
      document.body.appendChild(root);
    }

    const el = document.createElement('div');
    el.textContent = message;
    el.style.background = COLORS[kind];
    el.style.color = kind === 'error' ? '#fff' : '#fff';
    el.style.padding = '8px 12px';
    el.style.borderRadius = '6px';
    el.style.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
    el.style.fontFamily = 'Inter, system-ui, Arial, sans-serif';
    el.style.fontSize = '14px';
    el.style.opacity = '0';
    el.style.transition = 'opacity 160ms ease, transform 160ms ease';
    el.style.transform = 'translateY(-6px)';

    root.insertBefore(el, root.firstChild);

    // animate in
    requestAnimationFrame(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });

    // remove after ttl
    const t = setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(-6px)';
      setTimeout(() => {
        el.remove();
        if (root && root.childElementCount === 0) root.remove();
      }, 160);
      clearTimeout(t);
    }, ttl);

    return () => {
      clearTimeout(t);
      el.remove();
      if (root && root.childElementCount === 0) root.remove();
    };
  } catch (e) {
    // fallback
    console.warn('toast fallback', e);
    try { alert(message); } catch {}
    return () => {};
  }
}
export default showToast;
  